import React from 'react';
import classnames from 'classnames';

export default class Intro extends React.Component {
  render() {
    const styles = {
      wrapper: classnames({
        intro: true,
      }),
      logoContainer: classnames({
        'intro--logo-container': true,
      }),
      logo: classnames({
        'intro--logo': true,
      }),
      logoBase: classnames({
        'intro--logo--base': true,
      }),
      logoAnniversary: classnames({
        'intro--logo--anniversary': true,
      }),
      beforeCrop: classnames({
        'intro--before-crop': true,
      }),
      afterCrop: classnames({
        'intro--after-crop': true,
      }),
    };

    return (
      <div className={styles.wrapper}>
        <div className={styles.beforeCrop}>
          <svg viewBox="0 0 100 5">
            <polygon points="0,5 100,0 100,5" fill="white" />
          </svg>
        </div>
        <div className={styles.logoContainer}>
          <div className={styles.logo}>
            <div className={styles.logoBase}></div>
            <div className={styles.logoAnniversary}></div>
          </div>
        </div>
        <div className={styles.afterCrop}>
          <svg viewBox="0 0 100 5">
            <polygon points="0,0 100,0 0,5" fill="white" />
          </svg>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Intro.jsx
 **/